module.exports = __webpack_public_path__ + "static/media/Screen_Shot_3.fb1c5a70.png";